import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { MaterialModule } from '../../material.module';
import { OperatorSigningLogsComponent } from './operator-signing-logs.component';
import { OperatorSigningLogsService } from './operator-signing-logs.service';

@NgModule({
    declarations: [OperatorSigningLogsComponent],
    imports: [
        CommonModule,
        FormsModule,
        DataTablesModule,
        MaterialModule,
    ],
    providers: [OperatorSigningLogsService],
    exports: [OperatorSigningLogsComponent],
})
export class OperatorSigningLogsModule {}
